const COLORS = {
    gray: 'stroke.primary',
    darkgray: 'stroke.secondary',
    green: 'accent.stroke.success',
    orange: 'accent.stroke.warning',
    purple: 'accent.stroke.review',
    blue: 'accent.stroke.blue',
    red: 'accent.stroke.error'
};
export { COLORS };
